import { createContext } from 'react';
import { AxiosContextProps } from './AxiosInterface';

export const AxiosContext =
  createContext<AxiosContextProps | undefined>(undefined);
